import './styles/graphic.scss';

import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'; // uncomment for geocoder
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'; // this too
// import 'regenerator-runtime/runtime';
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { select, selectAll } from 'd3-selection';
import { format } from 'd3-format';


dayjs.extend(utc);


const JSON_URL = 'https://ix.cnn.io/data/heat-min-max-records-us/records.json';

const getColor = (n) => {
  let clr = 'color-0';
  if (n > 105) {
    clr = 'color-4';
  } else if (n >= 100) {
    clr = 'color-3';
  } else if (n >= 96) {
    clr = 'color-2';
  } else if (n >= 91) {
    clr = 'color-1';
  }
  return clr;
};
// temperature_colors = { "< 90": "#FFAB90", "91-95": "#FF8B73", "96-99": "#FF6B57", "100-105": "#E94A3C", "> 105": "#C52622" }


const draw = (container, isMobile, json_data, day) => {
  const { data, data_date, time_cycle } = json_data;

  const heat_records_data = data
    .filter(d => d.type === 'himax' && +d.forecast_day === day)
    .map(
      d => ({
        city: `${d.city.split(' Area')[0]}, ${d.st}`,
        forecast: `<span class="deg">${d.value}</span>`,
        record: `<span class="deg">${d.rec}</span> <span class="rec_yr">(${d.rec_yr})</span>`,
        year: d.rec_yr,
        is_record: d.is_record,
        forecast_day: d.forecast_day,
        classList: `${(d.is_record) ? 'record' : ''} ${getColor(d.value)}`,
      }),
    ).sort((a, b) => a.city.localeCompare(b.city));


  const table = select('#graphic')
    .html('')
    .append('table');

  // const keys = Object.keys(heat_records_data[0]);
  const keys = ['City', 'Record', 'Forecast'];
  const comma = format(',');

  const thead = table.append('thead');
  const tbody = table.append('tbody');

  const th = thead.append('tr')
    .selectAll('th')
    .data(keys)
    .enter()
    .append('th')
    .attr('aria-role', 'columnheader')
    // .style('text-align', (d, i) => (i === keys.length - 1 && !isMobile ? 'right' : null))
    .html((d, i) => `<span class='header'>
					${d}
				</span>
				<span class='sorter ${i === keys.length - 1 && !isMobile ? 'right' : i === 0 ? 'ascending' : ''}'>
				</span>`);

  const tr = tbody.selectAll('tr')
    .data(heat_records_data)
    .enter().append('tr')
    .attr('aria-role', 'row')
    .attr('class', d => d.classList)
    .html(d => keys.map((key, index) => `<td class="${key}" aria-role='cell'>
							${key === 'value' ? comma(+d[key.toLowerCase()]) : d[key.toLowerCase()]}
						</td>`)
      .join(''));

  if (heat_records_data.length > 10) {
    let expanded = false;
    const extraRows = tbody.selectAll('tr:nth-child(n+11)');
    extraRows.classed('hidden', true);

    const button = select('#graphic').append('button')
      .attr('class', 'show-more')
      .text('Show more places')
      .on('click', function () {
        expanded = !expanded;
        extraRows.classed('hidden', !expanded);
        select(this).text(expanded ? 'Show fewer places' : 'Show more places');
        pymChild && pymChild.sendHeight();
      });
  }
  // th.on('click', (d, i, el) => {
  //   // sorting function
  //   const that = select(el[i]);
  //   const sorter = that.select('.sorter');
  //   const header = that.select('.header');
  //   const ascending = sorter.classed('ascending');
  //   const key = header.text().replace(/\s/g, '');

  //   selectAll('.sorter')
  //     .classed('ascending descending', false);

  //   sorter.classed('ascending', !ascending);
  //   sorter.classed('descending', ascending);

  //   tr.sort((a, b) => (ascending // sorted ascended, so sort descended
  //     ? (a[key] < b[key] ? 1 : a[key] === b[key] ? 0 : -1)
  //     : (a[key] < b[key] ? -1 : a[key] === b[key] ? 0 : 1)));
  // });

  pymChild && pymChild.sendHeight();
};

const start = async (container, isMobile) => {
  // fetch the data
  const response = await fetch(JSON_URL);
  const json_data = await response.json();
  draw(container, isMobile, json_data, 1);

  const forecastButtons = document.querySelectorAll('.forecast.button');

  const updateForecast = (event) => {
    const day = +event.target.dataset.day;
    draw(container, isMobile, json_data, day);
    // for (const layer of ['heatrisk-1', 'heatrisk-2', 'heatrisk-3']) {
    //   map.setLayoutProperty(layer, 'visibility', 'none');
    // }
    for (const b of forecastButtons) {
      b.classList.remove('active');
    }
    // map.setLayoutProperty(t, 'visibility', 'visible');
    event.target.classList.add('active');
  };

  const { forecast_days } = json_data;
  forecastButtons.forEach(
    (button, i) => {
      button.addEventListener('click', updateForecast);
      button.innerHTML = forecast_days[i];
    },
  );

  document.getElementById('mapbtns').classList.add('show');

  // last updated
  let updatedStamp = `Notes: Only places within 1°F or more of a record are listed. Last updated ${json_data.lastUpdatedStr}` || '';
  updatedStamp = updatedStamp.replace(/:\d+\s/, ' ');
  document.getElementById('timestamp').innerHTML = updatedStamp;
};

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  start(container, isMobile);
}
